import { isEmpty } from 'lodash';

import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
import getNonPDPQueryVariables from './getNonPDPQueryVariables';

const useProductBasicQueryOptions = ({
  id,
  slug,
  queryOptions,
  hookOptions,
}) => {
  const {
    skipPDPStateHook = false,
    delayLoad = false,
    productSku = '',
    regionId,
  } = queryOptions;

  const { skip = false } = hookOptions;

  const finalNonPDPQueryVariables = skipPDPStateHook
    ? getNonPDPQueryVariables(id, productSku, hookOptions)
    : {};

  const userLocation = useUserLocation();

  const locationVars = getVisitorLocationQueryVariables(
    userLocation?.stateShortName,
    regionId
  );

  const { variables, skip: skipPdpQuery } = usePDPApolloQueryVariables(
    id,
    slug,
    {
      skip: skipPDPStateHook,
    }
  );

  const skipPdpVariableQuery =
    productSku && skipPdpQuery ? false : skipPdpQuery;

  return {
    variables: skipPDPStateHook
      ? { ...finalNonPDPQueryVariables, ...locationVars }
      : { ...variables, ...locationVars },
    skip:
      skip ||
      skipPdpVariableQuery ||
      delayLoad ||
      (skipPDPStateHook && isEmpty(finalNonPDPQueryVariables)),
    context: { noBatch: true },
    ssr: queryOptions?.ssr ?? true,
  };
};

export default useProductBasicQueryOptions;
